// extracted by mini-css-extract-plugin
export default {"EmptyArea":"EmptyArea_AtbRU_v17-8-1","VerticalNav":"VerticalNav_F3FZT_v17-8-1","Title":"Title_fdIG5_v17-8-1"};